import type { IndicatorScope } from '@Application/Indicators/IndicatorScope';

/** Stable serialization of an indicator scope. */
const buildIndicatorScopeKey = (scope: IndicatorScope): string => {
	switch (scope.kind) {
		case 'account':
			return `account:${scope.accountId}`;
		case 'organization':
			return `organization:${scope.organizationId}`;
		case 'facility':
			return `facility:${scope.facilityId}`;
	}
};

export default buildIndicatorScopeKey;
